import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import 'react-tabs/style/react-tabs.css';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';


import DetailCalcResultTable from '../ResultsDetail/DetailCalcResultTable';

import Amount from 'components/Display/Amount';


class LineResultTab extends React.Component {
  state = {
  };

  constructor(props){
    super(props);
  }

  componentDidMount(){
  
  }


  render() {
    let claimData = this.props.claimData;
    let result = this.props.result;

    const marginStyle = 
    {
      margin: '5px'
    };

    return (      
        <div className="grid tight collapse840">
        <div className="col">
          <DetailCalcResultTable data={result.creditorLines} title={'Kröfuhafi'}/>
          {result.currentSum &&  <h6>Ofgreitt til kröfuhafa: <Amount data={result.currentSum.paymentsCreditorOverPaid}/></h6>}
        </div>
        <div className="col">
          <DetailCalcResultTable data={result.lawyerLines} title={'Lögmaður'}/>
          {result.currentSum && <h6>Ofgreitt til lögmanns: <Amount data={result.currentSum.paymentsLawyerOverPaid}/></h6>}
        </div>
      </div>
    );
  }
}

LineResultTab.propTypes = {
  claimData : PropTypes.object, 
  result : PropTypes.object, 
};



export default LineResultTab;




// WEBPACK FOOTER //
// ./src/pages/Calculation/Tabs/LineResultTab.js